import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { DELIVERY_FORM_FIELDS } from '../constants';
import type { MeetingsAvailable } from '../types';

export const useFieldsControl = (data: MeetingsAvailable) => {
  const { setValue, watch } = useFormContext();

  const dateValue = watch(DELIVERY_FORM_FIELDS.DATE_SLOT);

  useEffect(() => {
    setValue(DELIVERY_FORM_FIELDS?.TIME_SLOT, data?.find(({ date }) => date === dateValue)?.intervals?.[0]?.slotId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateValue, setValue]);
};
